import { useIntl } from 'react-intl';

import { useAnalytics } from '@/hooks/analytics';
import redirect from '@/utils/legacy/redirect';

import messages from './messages';
import { Background, BodyText, ContentWrapper, CtaButton, Heading, MobileBreak, Wrapper } from './styles';

const ThankYou = () => {
	const { formatMessage } = useIntl();
	const { logEventAsync } = useAnalytics();

	const onClick = async () => {
		await logEventAsync({
			eventName: 'Schools : Resources : CTA : Clicked',
			eventProps: {
				copy: messages.heading.defaultMessage,
				type: 'button',
			},
		});
		redirect('/');
	};

	return (
		<Wrapper>
			<Background src="/_n/images/schools/take-care-collage.webp" />
			<ContentWrapper columns={1}>
				<Heading>
					{formatMessage(messages.heading, {
						mobileBreak: <MobileBreak />,
					})}
				</Heading>
				<BodyText>{formatMessage(messages.body)}</BodyText>
				<CtaButton backgroundColor="schoolBlue" onPress={onClick}>
					{formatMessage(messages.cta)}
				</CtaButton>
			</ContentWrapper>
		</Wrapper>
	);
};

export default ThankYou;
